import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { internalApi } from '../services/api';
import { isCustomDomain } from '../utils/routing';

export default function ShortUrlInternalRedirect({ isReferral = false }: { isReferral?: boolean } = {}) {
  const { positionUuid } = useParams<{ positionUuid: string }>();
  const navigate = useNavigate();

  const portalPrefix = isReferral ? 'referral' : 'internal';
  const apiPath = isReferral
    ? `/hiring/positions/${positionUuid}/referral`
    : `/hiring/positions/${positionUuid}/internal`;

  useEffect(() => {
    if (!positionUuid) {
      navigate('/404', { replace: true });
      return;
    }

    internalApi.get(apiPath)
      .then((response) => {
        const applyUrl: string = isReferral
          ? response.data.apply_url
          : response.data.internal_apply_url;
        if (!applyUrl) {
          navigate('/404', { replace: true });
          return;
        }
        let pathname = new URL(applyUrl).pathname;
        // Replace the prefix path segment to match the portal type
        if (isReferral) {
          // For referral, build the path from position data
          const clientCode = response.data.client_code;
          const slug = response.data.slug || '';
          pathname = `/${portalPrefix}/${clientCode}/${slug}/${positionUuid}`;
        } else {
          // On custom domain, strip the clientSlug from /internal/{clientSlug}/{clientUuid}/...
          // to get /internal/{clientUuid}/...
          // For custom domain clients the backend already omits clientSlug (4 parts),
          // so only strip when there are 5 parts.
          if (isCustomDomain()) {
            const parts = pathname.split('/').filter(Boolean);
            // 5 parts: ["internal", clientSlug, clientUuid, posSlug, posUuid] → strip clientSlug
            // 4 parts: ["internal", clientUuid, posSlug, posUuid] → already correct
            if (parts.length >= 5 && parts[0] === 'internal') {
              pathname = '/internal/' + parts.slice(2).join('/');
            }
          }
        }
        navigate(pathname, { replace: true });
      })
      .catch(() => {
        navigate('/error', { replace: true });
      });
  }, [positionUuid, navigate, apiPath, isReferral, portalPrefix]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-8 h-8 border-4 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
    </div>
  );
}
